import { render, staticRenderFns } from "./AddCTABlockModal.vue?vue&type=template&id=2c98025f&lang=pug&"
import script from "./AddCTABlockModal.vue?vue&type=script&lang=js&"
export * from "./AddCTABlockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports